import { Theme } from '@mui/material/styles';

import { theme, hosTheme } from 'src/styles/theme';
import { Themes } from 'src/shared/enum/Themes';

import { DesignMap } from './types/DesignMap';
import { Title } from './enum/Title';
import { Favicon } from './enum/Favicon';

const designsMap: Record<string, DesignMap> = {
    [process.env.REACT_APP_VITA_STUDENT_DOMAIN as string]: {
        brand: Title.VITA_STUDENT,
        favicon: Favicon.VITA_STUDENT,
        theme,
        themeName: Themes.VITA_STUDENT,
    },
    [process.env.REACT_APP_HOS_DOMAIN as string]: {
        brand: Title.HOUSE_OF_SOCIAL,
        favicon: Favicon.HOUSE_OF_SOCIAL,
        theme: hosTheme,
        themeName: Themes.HOUSE_OF_SOCIAL,
    },
};

const updateTitleAndFavicon = (design: DesignMap) => {
    document.title = design.brand as string;

    const faviconElement = document.querySelector('link[rel="icon"]');

    if (faviconElement instanceof HTMLLinkElement) {
        faviconElement.href = design.favicon as string;
    }
};

export const getTheme = (): {
    themeName: Themes;
    theme: Theme;
    isHosTheme: boolean;
    brand: Title;
} => {
    const { hostname } = window.location;

    const mainTheme = Object.values(designsMap)[0];

    const design = designsMap[hostname] || mainTheme;

    updateTitleAndFavicon(design);

    return {
        isHosTheme: design.themeName === Themes.HOUSE_OF_SOCIAL,
        themeName: design.themeName,
        brand: design.brand,
        theme: design.theme,
    };
};
